import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchStockOutReport } from 'utils/api/stockOutReportApi'
import { filterEmptyValues } from 'utils/helpers'
import { columns, FILTER_FIELD_STOCK_OUT_REPORT } from './utils'

const StockOutReportTable = () => {
  const [response, setResponse] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  const { getAllQueries } = useQuery()
  const { search } = useLocation()

  const getStockOutReport = async () => {
    setLoading(true)
    try {
      const queries = getAllQueries()
      const { limit, page } = queries
      // All filter controls persist under a single URL key; flatten them into
      // top-level query params (search, store, barcode, status, hierarchy and
      // the two date ranges).
      const filters = filterEmptyValues(
        queries[FILTER_FIELD_STOCK_OUT_REPORT] || {},
      )

      const { data } = await fetchStockOutReport(filters, {
        limit: limit || 10,
        page: page || 1,
      })

      setResponse(data)
    } catch (error) {
      setResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStockOutReport()
  }, [search])

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : response?.docs}
        identifier="_id"
      />

      <DataTablePagination
        currentPage={response?.page}
        totalPages={response?.totalPages}
        hasNextPage={response?.hasNextPage}
        hasPrevPage={response?.hasPrevPage}
        limit={response?.limit}
        nextPage={response?.nextPage}
        prevPage={response?.prevPage}
        disabled={loading}
      />
    </>
  )
}

export default StockOutReportTable
